import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, ActivatedRoute, RouterStateSnapshot, UrlTree, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from './services/login.service';
import * as _ from 'lodash'
import { stat } from 'fs';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {
  constructor(private activeRoute: ActivatedRoute, private router: Router, private _loginService: LoginService) {
  }
  returnUrl;
  user;
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const currentUser = this._loginService.currentUserValue;
    const user = this._loginService.userRolesValue;

    console.log('---------------------------------------', this.returnUrl);
    this.returnUrl = this.activeRoute.snapshot.queryParams['returnUrl'];


    console.log("what is the return url data", route , user);
    if (user != null) {
      let keys = Object.keys(user);

      if (route.data.roles) {

        var res = route.data.roles.filter(function (v) {
          return keys.indexOf(v) > -1;
        })

        if (res.length <= 0) {
          console.log("NOT AUTHORIZED")
          // role not authorised so redirect to equivalent page
          if (user.isAdmin) {
            this.router.navigate(['/dashboard']);
          } else if (user.isTrainer || user.isMp || user.isIQA) {
            this.router.navigate(['/scheduler']);
          } else if (user.isClient) {
            this.router.navigate(['/jobs']);
          } else if (user.isLearner) {
            if (this.returnUrl) {
              this.router.navigate(this.returnUrl)
            } else {
              this.router.navigate(['/user/' + currentUser._id]);
            }
          }

          return false;
        }
      }

      // if (route.data.permission) {
      //   let userPermissions = this._loginService.userPermissionValue;
      //   console.log('%croute.data.permission ', "color:DeepPink", route.data.permission)
      //   let compPermission = route.data.permission;
      //   // let userPermissions = Object.keys(permissionSet)
      //   console.log("userPermissions", userPermissions);

      //   compPermission.forEach(element => {
      //     console.log('userPermissions.includes(element)', userPermissions.includes(element))
      //     if (userPermissions.includes(element)) {
      //       return true
      //     } else {
      //       return false
      //     }
      //   });
      // } else {
      //   // return false
      // }

      return true;
    }
    // const userType: string = route.queryParams.user;
    console.log("this is else in auth guard", state, state.url.includes('mydocuments'))
    if (state.url.includes('mydocuments')) {
      this.router.navigate(['login/'], { queryParams: { returnUrl: state.url } });
    } else {
      this.router.navigate(['/login'])
    }
    return false;
  
}

}


